import React, { Component } from 'react';
import { Button, Form, Message } from 'semantic-ui-react';

import { auth } from '../firebase';

const initialState = {
  passwordOne: '',
  passwordTwo: '',
  error: false,
  message: false,
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    auth
      .updatePassword(this.state.passwordOne)
      .then(() => {
        this.setState(() => ({ ...initialState }));
        this.setState({ message: 'Password has been successfully updated' });
      })
      .catch(error => this.setState({ error }));
  }

  render() {
    const isInvalid =
      this.state.passwordOne === '' ||
      this.state.passwordOne !== this.state.passwordTwo;
    return (
      <Form size="large" onSubmit={this.handleSubmit}>
        <Form.Input
          value={this.state.passwordOne}
          name="passwordOne"
          onChange={event => this.handleChange(event)}
          placeholder="New Password"
          type="password"
          icon="lock"
          fluid
          iconPosition="left"
        />
        <Form.Input
          value={this.state.passwordTwo}
          name="passwordTwo"
          onChange={event => this.handleChange(event)}
          placeholder="Confirm New Password"
          type="password"
          icon="lock"
          fluid
          iconPosition="left"
        />
        <Button
          disabled={isInvalid}
          type="submit"
          color="orange"
          fluid
          size="large"
        >
          Set New Password
        </Button>
        <Message negative hidden={!this.state.error}>
          {this.state.error.message}
        </Message>
        <Message positive hidden={!this.state.message}>
          {this.state.message}
        </Message>
      </Form>
    );
  }
}

export default PasswordChangeForm;



// WEBPACK FOOTER //
// ./src/components/PasswordChangeForm.jsx